import {Component, Input, OnInit} from '@angular/core';
import {PopoverController} from "@ionic/angular";
import {CommonUtils} from "../../utils/common";
import {Category} from "../../models/category.model";

@Component({
  selector: 'app-category-select-menu',
  templateUrl: './category-select-menu.component.html',
  styleUrls: ['./category-select-menu.component.scss'],
})
export class CategorySelectMenuComponent implements OnInit {
  @Input() categories: Category[];

  constructor(
    private popoverController: PopoverController,
    public commonUtils: CommonUtils
  ) {
  }

  ngOnInit() {
  }

  handleButtonClick(category: Category) {
    this.popoverController.dismiss(category).then(r => {
    });
  }


}
